<template>
<div class="grid"  v-show="data.show">
<div class="col-12 md:col-2"><h5 class="mt-2 mb-0">{{data.title}}</h5></div>
<div class="col-12 md:col-10">
<InputNumber 
  :id="data.key" 
  v-model="data.value" 
  showButtons 
  buttonLayout="horizontal" 
  :step="data.steps"
  incrementButtonIcon="pi pi-plus" 
  decrementButtonIcon="pi pi-minus" 
  decrementButtonClass="p-button-primary p-button-outlined"
  incrementButtonClass="p-button-primary p-button-outlined"
  class="w-full p-inputtext-sm"
  input="emitValue"
  mode="decimal" 
  :minFractionDigits="0" 
  :maxFractionDigits="10"
 />

</div>  
  

  <small :id="data.key+'-help'" class="p-error pt-2" v-if="data.has_error"><b> {{data.title}}</b> {{data.error_message}}</small>


</div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {

  name: 'InputNumberValidate',
  props:["data","fieldindex"],
  data () {
    return {
    	inputdata:null,
    }
  },
  computed:{
  	dataValue()
  	{
  		return this.data.value
  	}
  },
  watch:{
  	dataValue(newVal,oldVal)
  	{
  		this.inputdata = this.dataValue
  	}
  },
  methods:{
  	emitValue()
  	{
  		this.$emit("emitValue",{value:this.inputdata,index:this.fieldindex})
  	},
  }
};
</script>

<style lang="css" scoped>
</style>